import { Col, Row } from "@zendeskgarden/react-grid";
import React from "react";
import { t } from "../../translations/translation.service";
import style from "./index.module.scss";

export interface ApplicationFormAnswerItem {
  questionText: string;
  type: string;
  candidateAnswer: string;
  parameterLabel: string;
  minimumExpected: string;
  metMinimum: boolean | null;
}

export interface ApplicationFormCandidateAnswers {
  professionalId: string;
  name: string;
  email: string;
  answeredAt: string;
  score: { met: number; total: number };
  items: ApplicationFormAnswerItem[];
}

function renderStatus(item: ApplicationFormAnswerItem) {
  if (item.metMinimum === null) {
    return null;
  }

  return item.metMinimum ? (
    <span className={style["status-met"]}>{"\u2714"}</span>
  ) : (
    <span className={style["status-unmet"]}>{"\u2718"}</span>
  );
}

export function scorePercentage(score: { met: number; total: number }): number {
  if (!score.total) {
    return 0;
  }
  return Math.round((score.met / score.total) * 100);
}

export function ApplicationFormScore(props: Readonly<{ score: { met: number; total: number } }>) {
  return (
    <div className={style["score"]}>
      {`${props.score.met} ${t("PontuacaoDe")} ${props.score.total} ${t("RequisitosAtendidos")} - ${scorePercentage(props.score)}%`}
    </div>
  );
}

export default function ApplicationFormAnswersList(props: Readonly<{ items: ApplicationFormAnswerItem[] }>) {
  return (
    <>
      {props.items.map((item) => (
        <div className={style["answer-row"]} key={`${item.questionText}-${item.type}`}>
          <Row>
            <Col sm={8}>
              <div className={style["answer-question"]}>{item.questionText}</div>
              <div>{item.candidateAnswer || t("SemResposta")}</div>
              {item.minimumExpected && (
                <div className={style["answer-parameter"]}>
                  {`${item.parameterLabel || t("ParametroDaResposta")}: ${item.minimumExpected}`}
                </div>
              )}
            </Col>
            <Col sm={4} className="text-right">
              {renderStatus(item)}
            </Col>
          </Row>
        </div>
      ))}
    </>
  );
}
